const labels = {
    en: {
        title: "Knowledge Transfer",
        // subtitle_1: 'Diagnosis:',
        parag_1: 'Patient is currently above their A1C target. The Diabetes Canada guidelines recommend further intensification to reach the patient’s individualized A1C target within 3 to 6 months.',

        reference: [
            'Diabetes Canada Clinical Practice Guidelines Expert Committee, Lipscombe L, Booth G, et al. Pharmacologic glycemic management of type 2 diabetes in adults. Can J Diabetes 2018;42 Suppl 1:S88-S103. doi:10.1016/j.jcjd.2017.10.034',

            "Cheng AYY, Wolever TMS, John Mancini GB. Time to rethink reducing cardiovascular risk: are we ready? Can J Diabetes 2020;44(1):1-3. doi:10.1016/j.jcjd.2019.10.010"
        ]
    },
    fr: {
        title: "Le transfert du savoir",        
        // subtitle_1: 'Diagnostic:',
        parag_1: 'Le taux d’hémoglobine glyquée (HbA<sub>1C</sub>) de ce patient est actuellement au-dessus de la cible. Les lignes directrices de Diabète Canada recommandent d’intensifier le traitement afin que le patient atteigne son taux cible d’HbA<sub>1C</sub> en 3 à 6 mois.  ',

        reference: [
            'Comité d’experts des Lignes directrices de pratique clinique de Diabète Canada, Lipscombe L, Booth G, et al. Prise en charge pharmacologique de la glycémie chez les adultes atteints de diabète de type 2. Can J Diabetes 42 (2018) S88-S103. doi : 10.1016/j.jcjd.2017.10.034.',

            "Cheng AYY, Wolever TMS, John Mancini GB. Time to rethink reducing cardiovascular risk: are we ready? Can J Diabetes 2020;44(1):1-3. doi : 10.1016/j.jcjd.2019.10.010."
        ]
    }
};

export default labels